// Callback function to execute when mutations are observed
window.events = window.events || {};
window.events.cognito = window.events.cognito || {};
window.events.cognito.buttonMapped = false;

window.events.cognito.getLabel = function (element) {
  var text = '';
  var _parentNode = element.parentNode;
  if (_parentNode.querySelector('legend.cog-label') != null) {
    text = _parentNode
      .querySelector('legend.cog-label')
      .innerHTML.replace(/<\/?[^>]+(>|$)/g, '')
      .replace(/ /g, '')
      .replace('\n\t\t\t', '');
    return text;
  }

  return window.events.cognito.getLabel(_parentNode);
};

const callback = (mutationList, observer) => {
  /* kitchen design appointment form start */
  // Select the form elements
  const selectFields = document.querySelectorAll('#cognito-form select');
  const sendToInput = document.querySelector('input[placeholder*="hidden-field Email send to"]');
  const storeIdInput = document.querySelector('input[placeholder="hidden-field store id"]');
  const calcInput = document.querySelector('.cog-html.cog-input pre');
  const storeIds = document.querySelectorAll('.cog-html.cog-input pre')[1];
  const userAgent = document.querySelector('input[placeholder="hidden-field userAgent"]');

  if (
    navigator.userAgent.toLowerCase().indexOf('fb4a') != -1 &&
    navigator.userAgent.toLowerCase().indexOf('fb_iab') != -1 &&
    navigator.userAgent.toLowerCase().indexOf('linux') != -1 &&
    navigator.userAgent.toLowerCase().indexOf('safari') != -1
  ) {
    var xx = setInterval(function () {
      if (document.querySelector('.cog-button[type="submit"]') != null) {
        document.querySelector('.cog-button[type="submit"]').remove();
        clearInterval(xx);
      }
    }, 100);
  }
  if (userAgent != null) {
    userAgent.value = window.navigator.userAgent;

    // If the event is not triggerd congnito will not treat the value change as an action and still send it blank.
    userAgent.dispatchEvent(new Event('keydown'));
    userAgent.dispatchEvent(new Event('change'));
  }

  const internationalAllowedCoutries = document.querySelector('[placeholder*="allowed-countries"]');
  if (internationalAllowedCoutries != null) {
    var allowed = JSON.parse(document.querySelector('[placeholder*="allowed-countries"]').value);
    document.querySelectorAll('.cog-picker select').forEach(e => {
      if (e.innerHTML.toLowerCase().indexOf('belgium') != -1) {
        if (document.querySelector('.js-message') == null) {
          var node = document.createElement('div');
          node.classList.add('js-message');
          e.after(node);
        }

        e.onchange = function (element) {
          console.log(element.target.value, allowed);
          var found = allowed.find(r => r.toLowerCase() == element.target.value.toLowerCase());
          document.querySelector('.cog-button--submit').style.display = 'block';
          document.querySelector('.js-message').innerHTML = '';
          if (found == null) {
            document.querySelector('.cog-button--submit').style.display = 'none';
            document.querySelector('.js-message').innerHTML =
              'We are sorry, but this brochure cannot be delivered to your selected country. To view it online, please <a style="text-decoration:underline;cursor:pointer" onclick="window.open(\'https://issuu.com/neptune-home/docs/ss25_directory_gbp?fr=sMWNiMjYzMzg3NTc\')">click here</a>.';
          }
        };
      }
    });
  }

  // Get the last select field - this is the field for the store
  let lastSelectField = null;
  document.querySelectorAll('.cog-label').forEach(e => {
    if (e.innerHTML.indexOf('your store') != -1 && e.innerHTML.indexOf('region') == -1) {
      lastSelectField = e.parentNode.querySelector('select');
    }
  });

  if (lastSelectField && lastSelectField.value && calcInput) {
    // Parse the CalculationArray data
    const rules = JSON.parse(calcInput.innerHTML);

    // Find the matching rule based on the selected value
    const matchedRule = rules.find(rule =>
      rule.toLowerCase().includes(lastSelectField.value.toLowerCase()),
    );

    if (storeIds != null && storeIdInput != null) {
      var storeIdsJson = JSON.parse(storeIds.innerHTML);
      var selectedStoreValue = storeIdsJson.filter(
        b => b.toLowerCase().indexOf(lastSelectField.value.toLowerCase()) != -1,
      );
      if (selectedStoreValue.length > 0) {
        const storeIdValue = selectedStoreValue[0].split('=')[1];
        storeIdInput.value = storeIdValue;
        // If the event is not triggerd congnito will not treat the value change as an action and still send it blank.
        storeIdInput.dispatchEvent(new Event('keydown'));
        storeIdInput.dispatchEvent(new Event('change'));
      } else {
        console.log('There is no store id associated with the value:' + lastSelectField.value);
      }
    }

    if (matchedRule) {
      // Extract the email and set the value of the send-to input field
      const email = matchedRule.split('=')[1];
      sendToInput.value = email;

      // If the event is not triggerd congnito will not treat the value change as an action and still send it blank.
      sendToInput.dispatchEvent(new Event('keydown'));
      sendToInput.dispatchEvent(new Event('change'));
    }
  }

  /* kitchen design appointment form end  */

  const submitBtn = document.querySelector('.cog-cognito button[data-action-name]');

  if (submitBtn == null || window.events.cognito.buttonMapped == true) {
    return;
  }

  submitBtn.addEventListener('click', e => {
    var fields = {};

    // Get the last select field - this is the field for the store
    let lastSelectField = null;
    document.querySelectorAll('.cog-label').forEach(e => {
      if (e.innerHTML.indexOf('your store') != -1 && e.innerHTML.indexOf('region') == -1) {
        lastSelectField = e.parentNode.querySelector('select');
        fields.storeValue = lastSelectField.value;
      }
    });

    document.querySelectorAll('.cog-label').forEach(e => {
      if (e.innerHTML.toLowerCase().indexOf('consultation type') != -1) {
        var value = e.parentNode.querySelector('[type="radio"]:checked')?.value;
        fields.consultationType = value;
      }
    });

    var buttonName = e.currentTarget.getAttribute('data-action-name');

    var index = 1;
    var elementIndex = 1;
    e.currentTarget
      .closest('form')
      .querySelectorAll('*[type], select')
      .forEach(element => {
        var inputValue = null;
        var label =
          element.getAttribute('autocomplete') ||
          element.getAttribute('placeholder') ||
          element.getAttribute('title') ||
          '';
        if (label == '') {
          label = window.events.cognito.getLabel(element);
        }

        if (element.getAttribute('type') == 'text') {
          inputValue = { type: element.getAttribute('type'), value: element.value, label: label };
        } else if (element.getAttribute('type') == 'radio' && element.checked == true) {
          inputValue = { type: 'radio', value: element.value, label: label };
        } else if (element.getAttribute('type') == 'checkbox' && element.checked == true) {
          inputValue = { type: 'checkbox', value: element.value, label: label };
        } else if (element.getAttribute('type') == 'date') {
          inputValue = { type: 'date', value: element.value, label: label };
        } else if (element.querySelectorAll('option').length > 0) {
          inputValue = {
            type: 'select',
            value: element.querySelector('option:checked').innerHTML,
            label: '',
          };
        }

        if (inputValue != null) {
          fields['capture' + elementIndex] = inputValue;
          elementIndex++;
        }
      });

    // left for debugging:
    console.log({
      event: 'cognito form submit',
      eventData: { formData: fields, buttonName: buttonName },
    });
    var q = setInterval(function () {
      if (document.querySelector('.cog-cognito button[data-action-name]') == null) {
        clearInterval(q);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'cognito form submit',
          eventData: { formData: fields, buttonName: buttonName },
        });
      }
      index++;

      if (index > 6) {
        clearInterval(q);
      }
    }, 1000);
  });

  window.events.cognito.buttonMapped = true;
};

const observer = new MutationObserver(callback);
observer.observe(document.querySelector('.cognito-embed'), {
  attributes: true,
  childList: true,
  subtree: true,
});
